const VERSION_STATUS: boolean = window.location.hostname.search('localhost') === -1;
const BETA_VERSION: boolean = window.location.hostname.search('beta') === -1;
const ARK_VERSION: boolean = window.location.hostname.search('4rk') === -1;
const MOBILE_VERSION: boolean = window.location.hostname.search('192.168.1.85') === -1;

// export const BASE_SITE = 'https://panel.mahi20.4rk.ir/';
// export const BASE_SITE = VERSION_STATUS ? 'https://panel.mahi20.4rk.ir/' : 'http://localhost/sanam/';
// export const BASE_SITE = 'https://panel.mahi20.4rk.ir/';
export const BASE_SITE = 'https://api.koochi.4rk.ir/seller/';
// const BASE_API = VERSION_STATUS ? 'api/v1/' : 'api/beta/';
const BASE_API = VERSION_STATUS && BETA_VERSION && ARK_VERSION && MOBILE_VERSION ? 'v1/' : 'v1/';

export const IMAGE_ADDRESS = 'https://koochi.4rk.ir/images/';


export const CHECK_LOGIN_GET = BASE_API + 'check-login';
export const GET_CAPTCHA_IMAGE = BASE_API + 'create_captcha';
export const LOGIN_POST = BASE_API + 'login'; //mobile
export const USERS_ACTIVATION_POST = BASE_API + 'activation'; // mobile, code
export const EDIT_PROFILE_POST = BASE_API + 'edit-profile'; // Authorization | title, logo
export const MY_PRODUCTS_GET = BASE_API + 'my-products'; // Authorization
export const ALL_PRODUCTS_GET = BASE_API + 'products'; // Authorization
export const ADD_PRODUCT_TO_STOCK_POST = BASE_API + 'add-to-stock'; // Authorization | product, inventory, price, priceOld
export const EDIT_PRODUCT_FROM_STOCK_POST = BASE_API + 'edit-from-stock'; // Authorization | product, inventory, price, priceOld
export const DELETE_PRODUCT_FROM_STOCK_POST = BASE_API + 'delete-from-stock'; // Authorization | product, inventory, price, priceOld
export const LOGOUT_GET = BASE_API + 'logout';
export const ORDERS_GET = BASE_API + 'orders';
export const EDIT_ORDER_GET = BASE_API + 'orders/edit';
export const CHANGE_ORDER_ITEM_STATUS = BASE_API + 'orders/change-status';
export const DELIVER_ORDER = BASE_API + 'orders/deliver';



export const VALIDATE_USER_BY_BARCODE = BASE_API + 'cashiers/validate_user_by_barcode'; //mobile
export const SEND_BUY_CODE_TO_USER = BASE_API + 'cashiers/send_code_to_user'; //mobile
export const VALIDATE_USER_BY_SMS = BASE_API + 'cashiers/validate_user'; //mobile
export const ADD_TRANS_POST = BASE_API + 'cashiers/add_trans'; 
export const TRANS_LIST_GET = BASE_API + 'cashiers/trans';
export const ACCUMULATIVE_TRANS_GET = BASE_API + 'cashiers/accumulative';
export const SETTLEMENTS_GET = BASE_API + 'cashiers/settlements';
export const GET_CASHIERS_OF_BRANCH = BASE_API + 'cashiers/get_cashiers_by_branch';
export const EDIT_FACTOR_NUM = BASE_API + 'cashiers/edit_factor_num';
export const REJECT_INSTALLMENTS_FACTOR = BASE_API + 'cashiers/reject_installments_factor';
export const PRINT_TRANS_EXTERNAL_LINK = BASE_SITE + BASE_API + 'cashiers/print/';
export const EXCEL_EXPORT_EXTERNAL_LINK = BASE_SITE + BASE_API + 'cashiers/excel_export/';
export const PDF_EXPORT_EXTERNAL_LINK = BASE_SITE + BASE_API + 'cashiers/pdf_export/';

export const INSTALLMENTS_FACTOR_GET = BASE_API + 'cashiers/installments_factor';
export const ACCEPT_INSTALLMENTS_FACTOR_POST = BASE_API + 'cashiers/accept_installments_factor';
export const CHECK_INSTALLMENTS_CODE = BASE_API + 'cashiers/validate_installments_barcode';
